<template>
  <div class="main">
    <div class="title">
      <div class="name"> 密码修改</div>
    </div>
    <div class="box">
      <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="旧密码" prop="oldPass">
          <el-input v-model="ruleForm.oldPass"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="pass" required>
          <el-input type="password" v-model="ruleForm.pass" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="checkPass" required>
          <el-input type="password" v-model="ruleForm.checkPass" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item>
          <span class="btn3" @click="submitForm('ruleForm')">确认修改</span>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import {updatePassword} from "@/api/index";
export default {
  name: "pass",
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (this.ruleForm.checkPass !== '') {
          this.$refs.ruleForm.validateField('checkPass');
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.ruleForm.pass) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      id:'',
      ruleForm: {
        pass: '',
        checkPass: '',
        oldPass: ''
      },
      rules: {
        pass: [
          { validator: validatePass, trigger: 'blur' }
        ],
        checkPass: [
          { validator: validatePass2, trigger: 'blur' }
        ],
        oldPass: [
          { required: true, message: '请输入旧密码', trigger: 'blur'  }
        ]
      }
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
  },
  components: {},
  created() {
    this.$emit("setActive", {
      active: 2,
      act: 1,
      name: '机构管理 > 密码修改'
    })
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.setpass()
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 获取列表
    async setpass() {
      let _res = await updatePassword(
          this.user.mid,
          this.ruleForm.oldPass,
          this.ruleForm.pass,
          this.ruleForm.checkPass,
      );
      if (_res.status === 200) {
        this.$message.success(_res.msg)
      } else {
        this.$message.error(_res.msg)
      }
    },

  },
  watch: {

  },
  filters: {}
}
</script>

<style scoped lang="scss">
.btn3 {
  display: block;
  width: 120px;
  height: 40px;
  background-color: #ff9600;
  border-radius: 20px;
  font-size: 14px;
  color: #ffffff;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
}
.main {
  background-color: #ffffff;
  border-radius: 10px;
  .title {
    padding: 5px 8px 15px 8px;
    .name {
      font-size: 20px;
      color: #ffffff;
      font-weight: bold;
    }
  }
  .box {
    width: 100%;
    border-radius: 10px;
    padding: 20px;
    background-color: #ffffff;
  }
}
</style>


